
import { FeatureCollection } from '../../hickory-api';

export class LocationInfo {
  coords: google.maps.LatLngLiteral;
  name: string;
}

export class MapLocation {
  textAddress: string = '';
  assetName: string = undefined;
  coords: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  confirmed: boolean = false;
  fromTemplate: boolean = false;
  fromAsset: boolean = false;
  get isZeroes(): boolean { return (this.coords?.lat || 0) === 0 && (this.coords?.lng || 0) === 0 }
  get isValidCoords(): boolean { return !this.isZeroes; }
  get isValidAddress(): boolean { return !!this.textAddress; }
  get isReady(): boolean { return this.isValidCoords && this.isValidAddress; }

  withLatLngLiteral(literal: google.maps.LatLngLiteral) {
    this.coords = literal;
    return this;
  }

  withLatLng(latLng: google.maps.LatLng) {
    this.coords = { lat: latLng.lat(), lng: latLng.lng() }
    return this;
  }

  withAddress(address: string) {
    this.textAddress = address;
    return this;
  }
}

// Map Selection interfaces
export interface MapSelection {
  SourceRecords?: SourceRecord[];
  geoJSON?: FeatureCollection;
  context?: any;
  mapThumbnailImageUrl?: string;
}
export interface LayerDef {
  featuresSource?: string
}
export interface SourceRecord {
  SourceId?: number;
  Label?: string;
  Count?: number;
  Status?: string;
  Enabled?: boolean;
  Recipients?: number[];
  LayerDef?: LayerDef;
  Selected?: boolean;
  isSourceValid?: boolean;
  DirectoryId?: string;
  LegacyGroupIds?: number[];
  GroupIds?: string[];
}
